<template>
  <div>
    <top-bar title="Meus Endereços" v-if="!component"/>
    <div>
      <loading v-if="load" :fullscrean="true"/>
      <div v-else>
        <div :class="{'container container-main': !component}" style="max-width: 600px">
          <div v-if="home">
            <a class="card text-dark mb-2" v-if="empresa.tipo_delivery !== '3'">
              <div class="d-flex align-items-center">
                <div class="text-center text-muted" style="width: 40px">
                  <icon name="retirada" class="text-primary" size="20"></icon>
                </div>
                <div class="py-4">
                  <h6 class="m-0 font-weight-bold">Retirar no local</h6>
                  <div class="small">
                    <b class="text-success">Grátis</b>
                    <span v-if="!agendamento"> / {{ empresa.media_retirada | tempo }}</span>
                  </div>
                </div>
              </div>
            </a>
            <div class="my-3 text-center">Selecione um endereço</div>
          </div>
          <div class="mb-2" v-for="(e, index) in dados.enderecos" :key="index">
            <a href="javascript:" class="card text-dark text-decoration-none" :class="e.selecionado === '1' ? 'selecionado' : ''" @click="selecionarEndereco(e, true)">
              <div class="d-flex align-items-center">
                <div class="text-center text-muted" style="width: 40px">
                  <icon name="home" size="20" v-if="e.tipo_endereco === '1'"></icon>
                  <icon name="work" size="20" v-else-if="e.tipo_endereco === '2'"></icon>
                  <icon name="address" size="20" v-else></icon>
                </div>
                <div class="py-4">
                  <div v-if="['1','2'].includes(e.tipo_endereco)">
                    <h6 class="m-0 font-weight-bold">{{e.tipo_endereco === '1' ? 'Minha Casa' : 'Meu Trabalho'}}</h6>
                    <div class="small">{{e.logradouro}}, {{e.numero}}</div>
                  </div>
                  <div v-else>
                    <h6 class="m-0 font-weight-bold">{{e.logradouro}}, {{e.numero}}</h6>
                    <div class="small">{{e.bairro}}<span class="text-nowrap" v-if="!ocultar_cidade">, {{e.nome_cidade}} - {{e.sigla_estado}}</span></div>
                  </div>
                </div>
                <div class="pointer ml-auto text-right px-3 py-4 text-nowrap" @click.stop="selecionarEndereco(e)">
                  <span class="mr-3 text-primary" v-if="e.selecionado === '1'"><i class="fa fa-check"></i></span>
                  <span><i class="fa fa-ellipsis-v text-muted"></i></span>
                </div>
              </div>
            </a>
          </div>
          <div v-if="!dados.enderecos.length">
            <div class="text-center p-3 mx-auto" :class="{'mt-1': !component}" style="max-width: 500px;">
              <icon name="address" class="text-primary" size="36"></icon>
              <div class="text-center mt-2">Nenhum endereço cadastrado</div>
            </div>
          </div>
          <div v-if="component">
            <hr>
            <a href="javascript:" @click="cadastrarEndereco()" class="btn btn-outline-primary btn-block">
              <i class="fa fa-plus mr-1"></i> Novo endereço
            </a>
          </div>
        </div>
        <div class="fixed-bottom bg-white fixed-container" v-show="step === 0" v-if="!component">
          <div class="p-3">
            <button class="btn btn-primary btn-block btn-bottom" @click="cadastrarEndereco()">Novo Endereço</button>
          </div>
        </div>
      </div>
    </div>

    <modal ref="modalEndereco" @voltar="fecharModalEndereco" @closeModal="step = 0" :title="endereco.logradouro_temp && step === 2 ? endereco.logradouro_temp : 'Novo Endereço'" :overflow="true">
      <div v-if="step > 0">
        <map-leaflet ref="map" :dados="empresa" v-show="ajustarLocal" @editarDados="retornoMapa"/>
      </div>

      <div v-show="!ajustarLocal">
        <div style="height: 100%" v-if="loadEndereco">
          <loading fullscrean="true"/>
        </div>

        <div v-show="!loadEndereco">
          <div class="container pt-3" v-if="step === 1">
            <div class="alert alert-warning small" v-if="empresa.limitar_cidade === '1' && !ocultar_cidade">
              <i class="fa fa-info-circle mr-1"></i> Entregas apenas para <b>{{empresa.nome_cidade}} - {{empresa.sigla_estado}}</b>
            </div>

            <div v-if="!cep_padrao">
              <modal-menu :menus="menus" :selected="menu" left="true" @changeMenu="toggleCepEndereco()" class="mb-3"/>

              <div class="mb-4" v-show="!place_padrao">
                <div class="alert alert-danger small mb-2" v-if="cepError"><i class="fa fa-warning mr-1"></i> Por favor, digite um cep válido.</div>
                <label for="cep" class="mb-0">Informe seu CEP</label>
                <div class="mb-2">
                  <the-mask id="cep" type="tel" :mask="['#####-###']" class="form-control" placeholder="Ex: 14403-110" v-model="endereco.cep" @keyup.native.enter="buscarCep(true)"/>
                </div>
                <button class="btn btn-primary btn-block" @click="buscarCep(true)">
                  <i class="fa fa-search"></i><span class="ml-2">Buscar CEP</span>
                </button>
              </div>
            </div>

            <form @submit.prevent="buscarPlaces" v-show="place_padrao">
              <label for="logradouro" class="mb-0">Rua/Avenida</label>
              <div class="small mb-1">
                Informe apenas a rua, por favor <b>não</b> coloque o bairro ou o número da casa.
              </div>
              <div class="mb-2">
                <input id="logradouro" type="search" class="form-control" placeholder="Ex: Rua Joaquim de Oliveira"
                       v-model="endereco.logradouro" @keyup.enter="buscarPlaces" minlength="6" required/>
              </div>
              <button class="btn btn-primary btn-block">
                <i class="fa fa-search"></i><span class="ml-2">Pesquisar Rua/Avenida</span>
              </button>
            </form>

            <div class="my-3" v-show="pesquisarLogradouro">
              <div class="d-flex align-items-center pointer" v-for="p in places" @click="selPlace(p)" style="padding: 8px 0">
                <div class="text-left" style="width: 40px">
                  <icon name="address" size="24" class="text-muted"></icon>
                </div>
                <div>
                  <div class="text-muted font-weight-bold">{{p.title}}</div>
                  <div class="small">{{p.description}}</div>
                </div>
              </div>
              <div class="d-flex align-items-center pointer" @click="buscarMapa()" style="padding: 8px 0" v-if="places.length">
                <div class="text-left" style="width: 40px">
                  <icon name="map" size="24" class="text-muted"></icon>
                </div>
                <div>
                  <div class="text-primary font-weight-bold">Não achei meu endereço</div>
                  <div class="small" @click="buscarMapa()">Buscar pelo mapa</div>
                </div>
              </div>
              <div class="py-4 text-center" style="margin: 16px 0" v-if="!places.length">
                <icon name="address" size="24"></icon>
                <h6 class="mt-2 mb-0">Rua/Avenida não encontrado</h6>
                <a href="javascript:" class="text-primary" @click="buscarMapa()">Buscar pelo mapa</a>
              </div>
            </div>

            <div class="text-center" v-if="!cep_padrao && !place_padrao">
              <h6 class="mb-1">Não sabe o CEP?</h6>
              <a href="javascript:" class="text-primary" @click="toggleCepEndereco()">Buscar pelo endereço</a>
            </div>

            <div class="my-4" v-if="isMobile && !pesquisarLogradouro && !gpsError && !geoDisabled"><hr>
              <a href="javascript:" @click="buscarGPS">
                <card-info title="Usar minha localização" icon="address" icon-pos="fa-angle-right">
                  <div class="small">Clique para buscar seu endereço</div>
                </card-info>
              </a>
            </div>
          </div>

          <div v-show="step === 2">
            <form @submit.prevent="validar">
              <div class="container container-endereco">
                <div class="alert alert-warning small" v-if="empresa.limitar_cidade === '1' && !ocultar_cidade">
                  <i class="fa fa-info-circle mr-1"></i> Entregas apenas para <b>{{empresa.nome_cidade}} - {{empresa.sigla_estado}}</b>
                </div>
                <div class="row" v-if="(!cep_padrao || empresa.limitar_cidade !== '1') && !ocultar_cidade">
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label for="cep" class="mb-0">CEP{{empresa.limitar_cidade === '0' ? '*' : ' (Opcional)'}}</label>
                      <the-mask id="cep2" type="tel" :mask="['#####-###']" class="form-control mb-1 mr-md-1" placeholder="Ex: 14403-110" v-model="endereco.cep"
                                @blur.native="buscarCep()" :required="!endereco.nome_cidade" v-if="step === 2"/>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label class="mb-0">Cidade*</label>
                      <div class="form-control bg-light" @click="alertaCidade" style="border-radius: 18px">{{endereco.nome_cidade}} - {{endereco.sigla_estado}}</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group mb-2">
                      <label for="endereco" class="mb-0">Rua/Avenida*</label>
                      <input id="endereco" type="text" class="form-control" placeholder="Ex: Rua Joaquim de Oliveira" maxlength="256" v-model="endereco.logradouro_temp" :disabled="!cep_padrao && !geoDisabled" required>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label for="numero" class="mb-0">Número*</label>
                      <input id="numero" type="tel" class="form-control" placeholder="Ex 1170" maxlength="11" v-model="endereco.numero" required>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label for="bairro" class="mb-0">Bairro*</label>
                      <input id="bairro" type="text" class="form-control" placeholder="Ex Centro" maxlength="45" v-model="endereco.bairro" required>
                    </div>
                  </div>
                  <div class="col-md-12" v-if="cep_padrao && empresa.limitar_cidade === '1' && !ocultar_cidade">
                    <div class="form-group mb-2">
                      <label for="bairro" class="mb-0">Cidade*</label>
                      <div class="form-control bg-light" @click="alertaCidade" style="border-radius: 18px">{{endereco.nome_cidade}} - {{endereco.sigla_estado}}</div>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label for="complemento" class="mb-0">Referência*<span class="pl-1 text-muted small">({{endereco.complemento ? endereco.complemento.length : 0}} de 100)</span></label>
                  <textarea id="complemento" class="form-control" placeholder="Ponto de Referência (Ex: Casa amarela, portão preto..) / Complemento / Bloco / Apto" style="resize: none" v-model="endereco.complemento" maxlength="100" required></textarea>
                </div>

                <div class="mb-3" v-if="endereco.id_endereco">
                  <label class="mb-0">
                    <input type="checkbox" class="mr-1"
                           @change="endereco.selecionado = endereco.selecionado === '1' ? '0' : '1'"
                           :checked="endereco.selecionado === '1'">
                    Definir como meu endereço principal
                  </label>
                </div>

                <div class="form-group">
                  <div class="mb-2">Favoritar Endereço</div>
                  <div class="row no-gutters">
                    <div class="col-6 col-sm-4 pr-1">
                      <button type="button" class="btn btn-block" :class="endereco.tipo_endereco === '1' ? 'bg-primary text-white' : 'btn-light border'" @click="toggleTipoEndereco('1')">
                        <icon name="home" size="22" class="mr-2"></icon>
                        Casa
                      </button>
                    </div>
                    <div class="col-6 col-sm-4 pl-1">
                      <button type="button" class="btn btn-block" :class="endereco.tipo_endereco === '2' ? 'bg-primary text-white' : 'btn-light border'" @click="toggleTipoEndereco('2')">
                        <icon name="work" size="22" class="mr-2"></icon>
                        Trabalho
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="border-top btn-avancar fixed-container">
                <div class="p-3">
                  <button class="btn btn-primary btn-block btn-bottom">
                    <span v-if="loadEndereco"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
                    <span v-else>Salvar</span>
                  </button>
                </div>
              </div>

            </form>
          </div>

        </div>
      </div>
    </modal>

    <modal-bottom :opened="!!modalConfirmar" v-if="modalConfirmar">
      <div class="container">
        <h6 class="text-center">O que deseja fazer?</h6>
        <hr>
        <div class="d-flex mb-3">
          <button class="btn btn-dark btn-block m-1" @click="removerEndereco()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M205.5 44.6c-9.7 3.4-15.9 11.8-18.1 24.4-1.5 8.8-2.8 11.3-7.1 14.1-2.6 1.7-5.5 1.9-38.6 1.9-23 0-37.4.4-40.2 1.1-2.7.7-6.3 2.8-9 5.1-11.2 9.8-8.8 27.5 4.6 34.2l5.3 2.6h307.2l5.3-2.6c12.7-6.4 15.5-21.9 5.9-32.8-6.4-7.3-8.1-7.6-50.2-7.6-33.4 0-36.3-.1-38.9-1.9-4.3-2.8-5.6-5.3-7.1-14.1-2.3-12.9-8.4-21.1-18.5-24.5-6.4-2.2-94.5-2.1-100.6.1m-86 127.8c-4 1.7-9.5 7.2-11.1 11.3-.8 1.8-1.4 5.6-1.4 8.5 0 11.1 17 206.6 18.5 212.8 2.2 9.2 10.4 25.4 16.7 33 12.5 15 29.9 25.5 48.8 29.5 10.5 2.2 119.5 2.2 130 0 19.9-4.2 38.6-16 50.6-31.8 5.7-7.4 12.6-21.8 14.8-30.7 2-7.9 18.8-204.3 18.4-214.2-.3-5.6-.9-7.4-3.5-11-1.7-2.4-5-5.3-7.4-6.5l-4.2-2.3H256.1c-108.5.1-134.2.3-136.6 1.4"/></svg>
            Remover
          </button>
          <button class="btn btn-primary btn-block m-1" @click="editarEndereco(modalConfirmar)">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M127.5 45c-41.7 8.8-74 41.4-82.5 83.2-2 9.6-2 13-1.8 131.1l.3 121.2 2.2 7.7c4.9 17.1 11.2 29.6 21.3 42.1 13.9 17.2 32.8 29.2 56.8 36l7.7 2.2 120.9.3c105.1.2 122.1 0 129.1-1.3 44.2-8.2 77.6-41.6 86-85.8 2.3-12 2.2-150 0-155.5-6.7-16-29.9-17-38.3-1.7-1.5 2.7-1.8 10.6-2.3 76-.6 81-.2 76.7-7.6 91.5-5.4 11-17 22.4-28.4 27.8-14.9 7.1-7.1 6.7-134.9 6.7-93.7 0-116.5-.3-121-1.4-18.1-4.4-35.2-18-42.8-34.1-7.1-15-6.7-7.2-6.7-135s-.4-120 6.7-135c5.4-11.4 16.8-22.9 27.8-28.4 14.9-7.3 10.5-6.9 91.7-7.5l73.1-.6 4.4-3c13.8-9.7 11.8-30.6-3.4-37-3.3-1.3-13-1.5-76.5-1.4-67.4 0-73.5.2-81.8 1.9"/><path d="M395.2 44.4c-11.6 2.9-19.7 8-33.5 21.5-7.1 6.9-13.9 14.4-15 16.6-2.8 5.4-2.8 13.6 0 19 2.7 5 59.5 61.6 64.3 64.1 4.9 2.5 13.4 2.4 18.5-.3 2.2-1.1 9.7-7.9 16.7-15.1 10.9-11.2 13.2-14.1 16.6-21.3 4.7-9.8 6.2-16.2 6.2-26.4s-1.5-16.6-6.2-26.3c-7.3-15.4-22.6-27.8-38.9-31.7-7.7-1.8-21.4-1.8-28.7-.1M298 132.2c-2.7.7-14.7 12.1-53.8 51.1-27.7 27.6-51.2 51.6-52.2 53.2-1 1.7-6.2 20.3-11.5 41.5-8 31.7-9.6 39.5-9.3 44.2.5 6.6 3.3 11.5 9.1 15.5 7.2 5 10.5 4.6 53.7-6.2 21.2-5.3 39.8-10.5 41.5-11.5 1.6-1 25.6-24.5 53.2-52.2 53.4-53.6 52.3-52.3 52.3-61.8-.1-7.7-3-11.4-32.8-41.3-30.5-30.6-34.6-33.8-42.6-33.6-2.3 0-5.7.5-7.6 1.1"/></svg>
            Editar
          </button>
        </div>
        <div>
          <button type="button" class="btn btn-block p-3 mb-1 text-dark" @click="() => {this.modalConfirmar = false; this.step = 0}">Cancelar</button>
        </div>
      </div>
    </modal-bottom>

  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';
  import Loading from "../components/Loading";
  import Icon from "../components/Icon";
  import Modal from "../components/Modal";
  import MapLeaflet from "../components/maps/MapLeafleat";
  import ModalBottom from "../components/ModalBottom";
  import CardInfo from "../components/CardInfo";
  import TopBar from "../components/TopBar";
  import ModalMenu from "../components/ModalMenu";

  export default {
    name: 'Endereco',
    components: {ModalMenu, TopBar, CardInfo, ModalBottom, MapLeaflet, Modal, Icon, Loading, TheMask},
    props: ['component'],

    data() {
      return {
        load: true,
        token: localStorage.getItem('token'),
        loadEndereco: false,
        home: true,
        agendamento: false,

        url: '',
        step: 0,
        pesquisarLogradouro: false,
        cepError: false,
        ajustarLocal: true,
        modalConfirmar: false,

        endereco: {
          logradouro: '',
          logradouro_temp: '',
          numero: '',
          complemento: '',
          nome_cidade: '',
          ibge: '',
          bairro: '',
          cep: '',
          lat_endereco: '',
          long_endereco: '',
          tipo_endereco: '',
          selecionado: '',
        },

        cep_padrao: true,
        place_padrao: false,
        places: true,
        dados: {
          enderecos: []
        },

        isMobile: false,
        gpsError: false,
        geoDisabled: false,

        menu: 1,
        menus: [
          { nome: 'CEP', active: true },
          { nome: 'Endereço', active: true }
        ],
      }
    },

    methods: {
      buscarCep(valid) {
        if (!this.endereco.cep || this.endereco.cep.length !== 8) {
          if (valid) {
            this.$swal('Por favor informe um CEP válido!').then(() => {
              this.$helpers.focusrElement(this.step === 1 ? 'cep' : 'cep2');
            });
          }

          return;
        }

        if (this.loadEndereco) {
          return;
        }

        this.loadEndereco = true;
        this.$http.get('https://viacep.com.br/ws/'+ this.endereco.cep +'/json')
          .then(response => {
            const dados = response.data;
            this.loadEndereco = false;

            if (dados.erro) {
              this.cepError = true;
              this.endereco.cep = '';
              this.$swal('Por favor informe um CEP válido!').then(() => {
                this.$helpers.focusrElement(this.step === 1 ? 'cep' : 'cep2');
              });

              return;
            }

            if (dados.ibge !== this.empresa.ibge && this.empresa.limitar_cidade === '1') {
              this.endereco.cep = '';
              this.endereco.logradouro = '';
              this.$swal('Entregas aceitas apenas para ' + this.empresa.nome_cidade + ' - ' + this.empresa.sigla_estado + '. Localização informada: ' + dados.localidade + ' - ' + dados.uf);
              return;
            }
            
            this.cep_padrao = false;
            this.endereco.logradouro = dados.logradouro || '';
            this.endereco.logradouro_temp = dados.logradouro || '';
            this.endereco.bairro = dados.bairro || '';

            if (!dados.logradouro) {
              this.cep_padrao = true;
            }

            this.endereco.id_cidade = this.empresa.limitar_cidade === '1' ? this.empresa.id_cidade : null;
            this.endereco.ibge = dados.ibge;
            this.endereco.nome_cidade = dados.localidade;
            this.endereco.sigla_estado = dados.uf;
            this.step = 2;
            this.$helpers.focusrElement(!dados.bairro ? 'bairro' : 'numero');

          }, res => {
            console.log(res);
            this.loadEndereco = false;
            this.load = false;
          });
      },

      validar() {
        this.loadEndereco = true;

        if (!this.endereco.numero || this.endereco.numero.trim() === '') {
          this.loadEndereco = false;
          this.$swal('Por favor informe um número válido!');
          return false;
        }

        if (this.endereco.cep && this.endereco.cep.length < 8 && !this.cep_padrao && this.geoDisabled) {
          this.loadEndereco = false;
          this.$swal('Por favor remova ou informe um CEP válido').then(() => {
            this.$helpers.focusrElement('cep2');
          });

          return false;
        }

        if (!this.endereco.nome_cidade) {
          this.loadEndereco = false;
          this.$swal('Por favor informe um CEP válido para pesquisar sua cidade').then(() => {
            this.$helpers.focusrElement('cep2');
          });

          return false;
        }

        if (!this.geoDisabled && !this.endereco.buscar_mapa) {
          this.buscarGeocoding(1);

        } else {
          this.salvar();
        }
      },

      salvar(sel, endereco) {
        if (this.cep_padrao || this.geoDisabled) {
          this.endereco.logradouro = this.endereco.logradouro_temp;
        }

        this.loadEndereco = true;
        const url = this.$helpers.base_url(this, this.empresa);

        this.$http.post(url + this.token + "/endereco", this.endereco)
          .then(res => {
            this.loadEndereco = false;
            this.load = false;

            if (!res.data || !res.data.success || !res.data.dados) {
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
              return;
            }

            this.step = 0;
            this.ajustarLocal = false;
            this.$emit('closeModal');
            const dados = res.data.dados;
            this.$store.state.dataUser = dados;

            if (sel) {
              this.dados.enderecos.forEach(end => end.selecionado = '')
              endereco.selecionado = '1';

            } else {
              this.dados = dados;
            }

            this.$nextTick(() => {
              this.$emit('atualizar');

              if (!this.component) {
                if (this.sacola.id_zona) {
                  this.sacola.id_zona = null;
                  localStorage.setItem('sacola', JSON.stringify(this.sacola));
                }

                if (this.home) {
                  this.$router.push(this.url + '/home');
                }
              }
            });

          }, res => {
            console.log(res);
            this.load = false;
            this.loadEndereco = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');

            if (sel) {
              this.step = 0;
            }
          });
      },

      buscarPlaces() {
        if (!this.endereco.logradouro.trim().length || this.endereco.logradouro.trim().length < 6) {
          return;
        }

        this.loadEndereco = true;
        const pesquisa = { logradouro: this.endereco.logradouro };
        const url = this.$helpers.base_url(this, this.empresa);
        this.places = [];

        this.$http.post(url + "buscar-enderecos" , pesquisa)
          .then(res => {
            const dados = res.data;
            this.loadEndereco = false;
            this.pesquisarLogradouro = true;

            if (dados.success && dados.results && dados.results.length) {
              this.places = dados.results;

              if (this.places.length === 1) {
                this.selPlace(this.places[0]);
              }

            } else {
              this.$swal("Rua/Avenida não encontrado, verifique o endereço ou clique em buscar pelo mapa.").then(() => {
                this.$helpers.focusrElement("logradouro");
              });
            }

          }, res => {
            console.log(res);
            this.loadEndereco = false;
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            this.$swal(msg);
          });
      },

      buscarGeocoding(tipo) {
        let pesquisa = {
          logradouro: this.endereco.logradouro,
          numero: this.endereco.numero,
        };

        if (tipo === 2) {
          pesquisa = {
            latitude: this.endereco.lat_endereco,
            longitude: this.endereco.long_endereco
          }
        }

        this.loadEndereco = true;
        const url = this.$helpers.base_url(this, this.empresa);

        this.$http.post(url + "validar-endereco/" , pesquisa)
          .then(res => {
            this.loadEndereco = false;
            let dados = res.data;

            if (dados.success) {
              if (tipo === 2) {
                if (dados.results && dados.results.length) {
                  dados = dados.results;

                  const cep = dados.find(e => e.types.includes('postal_code'));
                  const logradouro = dados.find(e => e.types.includes('route'));
                  const bairro = dados.find(e => e.types.includes('sublocality'));

                  this.endereco.cep = cep ? cep.long_name.replace('-','') : '';
                  this.endereco.logradouro = logradouro && logradouro.long_name !== 'Unnamed Road' ? logradouro.long_name : '';
                  this.endereco.bairro = bairro ? bairro.long_name : '';
                  this.endereco.logradouro_temp = this.endereco.logradouro;
                  this.endereco.nome_cidade = this.empresa.nome_cidade;
                  this.endereco.sigla_estado = this.empresa.sigla_estado;
                  this.step = 2;
                  return;
                }

                this.$swal("Não conseguimos processar seu endereço. Insira manualmente.")

              } else {
                this.endereco.buscar_mapa = false;
                this.endereco.lat_endereco = dados.lat;
                this.endereco.long_endereco = dados.lng;
                this.ajustarLocal = true;
                this.$refs.map.openMapa(this.endereco);
              }

            } else {
              const msg = (tipo === 2) ? "Por favor verifique o local no mapa informado" : "Por favor busque pelo nome da Rua/Avenida";
              this.$swal("Endereço não encontrado! " + msg + " e tente novamente.").then(() => {
                if (tipo === 1 && this.empresa.limitar_cidade === '1') {
                  this.step = 1;
                  this.menu = 2;
                  this.place_padrao = true;
                  this.$nextTick(() => {
                    this.$helpers.focusrElement(this.place_padrao ? "logradouro" : "cep");
                  });
                }
              });
            }

          }, res => {
            this.loadEndereco = false;
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            this.$swal(msg);
          });
      },

      clearEndereco() {
        this.places = [];
        this.pesquisarLogradouro = false;
        this.cepError = false;
        this.ajustarLocal = false;
        this.cep_padrao = !!this.empresa.cep_cidade && this.empresa.limitar_cidade === '1';
        this.endereco = {
          logradouro: '',
          logradouro_temp: '',
          numero: '',
          complemento: '',
          nome_cidade: '',
          bairro: '',
          ibge: '',
          cep: '',
          sigla_estado: '',
          lat_endereco: '',
          long_endereco: '',
          tipo_endereco: !this.dados.enderecos.length ? '1' : '',
          id_cidade: this.empresa.limitar_cidade === '1' ? this.empresa.id_cidade : null,
          selecionado: ''
        };

        if (this.$refs.map) {
          this.$refs.map.remove();
        }
      },

      removerEndereco() {
        this.modalConfirmar = false;

        if (this.endereco.selecionado === '1') {
          this.$swal("Não é possível remover um endereço selecionado como principal.");
          return;
        }

        this.$swal({
          text: 'Tem certeza que deseja remover este endereço?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.load = true;
            this.endereco.delete = true;
            const url = this.$helpers.base_url(this, this.empresa);

            this.$http.post(url + this.token + "/endereco", this.endereco)
              .then(res => {
                this.load = false;

                if (!res.data || !res.data.success || !res.data.dados) {
                  this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
                  return;
                }

                this.dados = res.data.dados;
                this.$store.state.dataUser = this.dados;
                this.$swal('Endereço removido com sucesso!');

              }, res => {
                this.load = false;
                console.log(res);
              });
          }

          this.step = 0;
        });
      },

      selecionarEndereco(e, sel) {
        if (!sel) {
          this.modalConfirmar = e;

        } else if (e.selecionado !== '1') {
          this.editarEndereco(e, true, false)

        } else {
          this.$emit('fechar');
        }
      },

      editarEndereco(e, selecionar, local) {
        this.step = 2;
        this.cepError = false;
        this.ajustarLocal = false;
        this.endereco = {
          id_endereco: e.id_endereco,
          logradouro: e.logradouro,
          logradouro_temp: e.logradouro,
          numero: e.numero,
          complemento: e.complemento,
          nome_cidade: e.nome_cidade,
          ibge: e.ibge,
          id_cidade: e.id_cidade,
          sigla_estado: e.sigla_estado,
          bairro: e.bairro,
          cep: e.cep_endereco,
          lat_endereco: e.lat_endereco,
          long_endereco: e.long_endereco,
          tipo_endereco: e.tipo_endereco,
          selecionado: selecionar ? '1' : e.selecionado
        };

        if (selecionar) {
          this.load = true;
          this.salvar(true, e);
          return;

        } else if (local) {
          this.buscarGeocoding(1);
        }

        this.$emit('openModal');
        this.modalConfirmar = false;
      },

      cadastrarEndereco() {
        this.step = 1;
        this.clearEndereco();
        this.$emit('openModal');

        if (this.geoDisabled || this.empresa.limitar_cidade === '0') {
          this.step = 2;
          this.$helpers.focusrElement(this.cep_padrao ? 'bairro' : 'cep2');

          if (this.empresa.limitar_cidade === '1') {
            this.endereco.ibge = this.empresa.ibge;
            this.endereco.id_cidade = this.empresa.id_cidade;
            this.endereco.nome_cidade = this.empresa.nome_cidade;
            this.endereco.sigla_estado = this.empresa.sigla_estado;
          }

        } else if (this.isMobile) {
          this.$swal({
            text: 'Para cadastrar seu endereço podemos buscar sua localização?',
            buttons: ["Cadastrar manual", "Sim"]
          }).then((r) => {
            if (r) {
              this.buscarGPS();

            } else {
              this.$helpers.focusrElement(this.place_padrao ? "logradouro" : "cep");
            }
          });

        } else {
          this.$helpers.focusrElement(this.place_padrao ? "logradouro" : "cep");
        }
      },

      fecharModalEndereco() {
        if (this.ajustarLocal) {
          this.ajustarLocal = false;
          this.$refs.map.remove();

        } else if (!this.endereco.id_endereco && !this.geoDisabled && this.step === 2 && this.empresa.limitar_cidade === '1') {
          this.cep_padrao = !!this.empresa.cep_cidade && this.empresa.limitar_cidade === '1';
          this.step = 1;
          this.$nextTick(() => {
            this.$helpers.focusrElement(this.place_padrao ? "logradouro" : "cep");
          });

        } else {
          this.step = 0;
          this.clearEndereco();
          this.$emit('closeModal');

          if (!this.dados.enderecos.length) {
            this.$emit('fechar');
          }
        }
      },

      retornoMapa(local) {
        this.ajustarLocal = false;
        this.loadEndereco = true;
        this.endereco.lat_endereco = local.lat;
        this.endereco.long_endereco = local.lng;

        if (this.endereco.logradouro && this.endereco.numero && !this.endereco.buscar_mapa) {
          this.step = 0;
          this.salvar();

        } else {
          this.buscarGeocoding(2);
        }
      },

      toggleTipoEndereco(tipo) {
        this.endereco.tipo_endereco = tipo !== this.endereco.tipo_endereco ? tipo : '';
      },

      selPlace(p) {
        this.pesquisarLogradouro = false;
        this.endereco.logradouro = p.logradouro;
        this.endereco.logradouro_temp = p.logradouro;
        this.endereco.nome_cidade = this.empresa.nome_cidade;
        this.endereco.sigla_estado = this.empresa.sigla_estado;
        this.endereco.ibge = this.empresa.ibge;
        this.endereco.cep = this.cep_padrao ? this.empresa.cep : this.endereco.cep;
        this.step = 2;
        this.$helpers.focusrElement('bairro');
      },

      buscarGPS() {
        const msgIos = this.isIOS ? "\n\nAcessando com um Iphone? Verifique se está acessando nosso site diretamente pelo Safari." : "";
        this.gpsError = true;

        if(!navigator.geolocation) {
          this.$swal('Seu dispositivo não suporta geolocalização! ' + msgIos);

        } else {
          this.loadEndereco = true;

          navigator.geolocation.getCurrentPosition((position) => {
            this.gpsError = false;
            const latitude  = position.coords.latitude;
            const longitude = position.coords.longitude;
            this.endereco.buscar_mapa = false;
            this.endereco.lat_endereco = latitude;
            this.endereco.long_endereco = longitude;
            this.loadEndereco = false;
            this.ajustarLocal = true;
            this.$refs.map.openMapa(this.endereco);

          }, (positionError) => {
            this.loadEndereco = false;
            switch(positionError.code) {
              case positionError.PERMISSION_DENIED:
                this.$swal('Não temos permissão para usar sua localização. Limpe as preferências do App ou navegador para usar esta funcionalidade ou faça o cadastro manual do seu endereço! ' + msgIos);
                break;

              default:
                this.$swal('Não foi possível obter sua localização! ' + msgIos);
            }

          }, {
            enableHighAccuracy: true,
            timeout: 40000,
            maximumAge: 0
          });
        }
      },

      buscarMapa() {
        const latitude  = this.empresa.lat_cidade;
        const longitude = this.empresa.long_cidade;

        if (!latitude || !longitude) {
          return;
        }

        this.endereco.lat_endereco = latitude;
        this.endereco.long_endereco = longitude;
        this.endereco.buscar_mapa = true;
        this.loadEndereco = false;
        this.ajustarLocal = true;
        this.$refs.map.openMapa(this.endereco);
      },

      alertaCidade() {
        if (this.empresa.limitar_cidade === '1') {
          this.$swal('Entregas aceitas apenas para a cidade de ' + this.empresa.nome_cidade + ' - ' + this.empresa.sigla_estado);

        } else {
          this.$swal('Informe um CEP para alterar a cidade.');
        }
      },

      toggleCepEndereco() {
        this.place_padrao = !this.place_padrao;
        this.menu = this.place_padrao ? 2 : 1;
        this.$helpers.focusrElement(this.place_padrao ? "logradouro" : "cep");

        if (!this.place_padrao) {
          this.pesquisarLogradouro = false;
          this.places = [];
        }
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
      this.home = !!this.$route.query.home;

      if (this.token) {
        this.agendamento = this.empresa.ativo === '1' && this.empresa.aberto === '0' && this.empresa.entregas.length;
        this.isMobile = this.$helpers.isMobile();
        this.geoDisabled = (this.empresa.geo_disabled !== '0');
        this.dados = this.$store.state.dataUser;
        this.cep_padrao = !!this.empresa.cep_cidade && this.empresa.limitar_cidade === '1';

        if (this.cep_padrao) {
          this.place_padrao = true;
          this.endereco.cep = this.empresa.cep_cidade
        }

        this.load = false;
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });

      } else {
        this.$router.push(this.url + '/perfil/login');
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      sacola() {
        return this.$store.state.sacola
      }
    },

    created() {
      document.body.classList.remove("modal-open");
    },

    beforeRouteLeave(to, from, next) {
      if (this.$refs.modalEndereco && this.$refs.modalEndereco.opened) {
        this.step = 0;
        this.$emit('closeModal');

        if (!this.dados.enderecos.length) {
          next();

        } else {
          next(false);
        }

      } else {
        next()
      }
    },
  }
</script>

<style scoped>
  .btn-avancar {
    position:fixed;
    right:0;
    bottom:0;
    left:0;
    z-index:1030;
    background-color: #fff;
  }

  .container-main {
    padding-bottom: 100px;
  }

  .container-endereco {
    padding-top: 16px;
    padding-bottom: 100px;
    min-height: 100vh;
  }

  .selecionado {
    border: 1.5px solid var(--lecard-primary);
  }

  @media (min-width: 768px) {
    .btn-avancar {
      position:static;
      padding-right: 15px;
      padding-left: 15px;
    }

    .container-endereco {
      overflow: auto;
      min-height: auto;
      height: calc(80vh - 142px);
      padding-bottom: 0;
    }
  }
</style>
